export default __webpack_public_path__ + "static/media/78.53670869.jpg";